import React from 'react';

const FlashcardCard = ({ currentCard, flipped, flipCard }) => {
  const handleCardClick = () => {
    flipCard(!flipped);
  };

  return (
    <div className={`flashcard-card `} onClick={handleCardClick}>
      <div className="front">
        <h3 className='hh'>{flipped ? currentCard.answer : currentCard.question}</h3>
        <p className='p'>{flipped ? 'Click to see the question' : 'Click to see the answer'}</p>
      </div>
    </div>
  );
};

export default FlashcardCard;
